/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SliderCustomImageComponent as ɵa} from './lib/slider-custom-image/slider-custom-image.component';